export { default } from '@relo/sports-components/es/SearchSelect/index.js';
export * from '@relo/sports-components/es/SearchSelect/index.js';
